var map = {
	"./Airbrake/Security.md": 69824,
	"./Airtable/Security.md": 83137,
	"./Asana/Security.md": 85421,
	"./Axosoft/Security.md": 18361,
	"./AzureDevOps/Security.md": 91465,
	"./Backlog/Security.md": 37870,
	"./Bitbucket/Security.md": 58212,
	"./Breeze/Security.md": 21828,
	"./Bugasura/Security.md": 59045,
	"./Bugherd/Security.md": 85910,
	"./Bugsnag/Security.md": 58742,
	"./Bugzilla/Security.md": 36607,
	"./Clickup/Security.md": 92704,
	"./Datadog/Security.md": 75913,
	"./DevRev/Security.md": 38953,
	"./Favro/Security.md": 87733,
	"./Flock/Security.md": 25796,
	"./FogBugz/Security.md": 30507,
	"./Github/Security.md": 89176,
	"./GithubCopilotChat/Security.md": 1514,
	"./Gitlab/Security.md": 43872,
	"./GoodDay/Security.md": 96944,
	"./GoogleChat/Security.md": 7046,
	"./Hive/Security.md": 54051,
	"./Jira/Security.md": 47457,
	"./LinearApp/Security.md": 67227,
	"./Mantis/Security.md": 31145,
	"./Mattermost/Security.md": 95647,
	"./MicrosoftTeams/Security.md": 80415,
	"./Miro/Security.md": 14538,
	"./Monday/Security.md": 98793,
	"./NewRelic/Security.md": 98126,
	"./Notion/Security.md": 96066,
	"./PagerDuty/Security.md": 76870,
	"./Paymo/Security.md": 26945,
	"./PivotalTracker/Security.md": 76976,
	"./Practitest/Security.md": 6550,
	"./Redmine/Security.md": 46287,
	"./RocketChat/Security.md": 63211,
	"./Shopify/Security.md": 35849,
	"./Shortcut/Security.md": 81267,
	"./Slack/Security.md": 56919,
	"./SumoLogic/Security.md": 98457,
	"./TargetProcess/Security.md": 20157,
	"./Teamwork/Security.md": 54161,
	"./Trello/Security.md": 54351,
	"./Userback/Security.md": 84433,
	"./Webex/Security.md": 52994,
	"./Webhooks/Security.md": 92719,
	"./Wrike/Security.md": 8899,
	"./YouTrack/Security.md": 36651,
	"./Zenkit/Security.md": 5420,
	"./Zipboard/Security.md": 53042,
	"./ZohoBugTracker/Security.md": 84213,
	"./ZohoCliq/Security.md": 75164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66058;